import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { Container } from "./styles";

export const PDVHome = () => {
	const [user, setUser] = useState(null);

	useEffect(() => {
		const profile = localStorage.getItem("@profile");
		setUser(JSON.parse(profile));
	}, []);

	return (
		<Container>
			<header>
				{user && user.profile_photo && (
					<img
						loading='lazy'
						className='img-responsive'
						src={`${process.env.REACT_APP_URL_STORE}/${user.profile_photo}`}
						alt={user.store}
					/>
				)}
				{user && !user.profile_photo && (
					<img
						loading='lazy'
						className='img-responsive'
						src={require("@/assets/img/cao-e-gato.png").default}
						alt='cao e gato'
					/>
				)}
			</header>
			<div className='wellcome'>
				<p className='helloUser'>
					Olá,
					<br /> <span>{user?.store}</span>
				</p>
				<ul className='list-pets'>
					<li>
						<Link to={`${process.env.PUBLIC_URL}/scan-qrcode`}>
							<img
								loading='lazy'
								src={
									require("@/assets/img/qr-code-2.svg")
										.default
								}
								alt='qrcode'
							/>
							<span className='btn-primary'>
								Inserir cupom do cliente
							</span>
						</Link>
					</li>
				</ul>
			</div>
		</Container>
	);
};

export default PDVHome;
